// extracted by mini-css-extract-plugin
export default {"Controls":"DrawingToolsV3_Controls__+yqMH","Merge":"DrawingToolsV3_Merge__dETfI","DeleteButton":"DrawingToolsV3_DeleteButton__GCLYq"};